// Socket.io for Jute
import io from 'socket.io-client/dist/socket.io.js';
window.io = io

// regeneratorRuntime for async and await
import regeneratorRuntime from 'regenerator-runtime';

// react
import React from 'react';
import { Fragment, useState, useEffect, useRef, useReducer, useCallback } from 'react';

window.React = React;
window.Fragment = Fragment;
window.useState = useState;
window.useEffect = useEffect;
window.useRef = useRef;
window.useReducer = useReducer;
window.useCallback = useCallback;

import { createRoot } from 'react-dom/client';
window.createRoot = createRoot;

// ReactDOM.render is deprecated
window.reactDomRender = (component, element) => createRoot(element).render(component)

import { createPortal } from 'react-dom';
window.createPortal = createPortal;

import createReactClass from 'create-react-class';
window.createReactClass = createReactClass;

import { phash } from 'imagehash-web';
window.phash = phash

import isEmail from 'validator/lib/isEmail';
window.isEmail = isEmail;

import JSZip from 'jszip';
window.JSZip = JSZip;

import { localeIncludes } from 'locale-includes';
window.localeIncludes = localeIncludes;

// react-addons-update
import update from 'react-addons-update'
window.update = update;

// react-text-mask
import MaskedInput from 'react-text-mask';
window.MaskedInput = MaskedInput;

// react-router
import { withRouter, HashRouter, BrowserRouter, Link, Redirect } from 'react-router-dom';

window.withRouter = withRouter;
window.HashRouter = HashRouter;
window.BrowserRouter = BrowserRouter;
window.Link = Link;
window.Redirect = Redirect;

import { Route as RRRoute, Switch as RRSwitch } from 'react-router';
window.RRRoute = RRRoute;
window.RRSwitch = RRSwitch;

// react-window
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';
window.AutoSizer = AutoSizer;
window.FixedSizeList = FixedSizeList;

// stripe
import { StripeProvider, injectStripe, CardElement, Elements } from 'react-stripe-elements';
window.StripeProvider = StripeProvider;
window.injectStripe = injectStripe;
window.CardElement = CardElement;
window.Elements = Elements;

// clsx
import clsx from 'clsx';
window.clsx = clsx;

// material-ui
import Alert from '@material-ui/lab/Alert';
window.Alert = Alert;
import AlertTitle from '@material-ui/lab/AlertTitle';
window.AlertTitle = AlertTitle;

import AppBar from '@material-ui/core/AppBar';
window.AppBar = AppBar;

import Avatar from '@material-ui/core/Avatar';
window.Avatar = Avatar;

import Badge from '@material-ui/core/Badge';
window.Badge = Badge;

import Box from '@material-ui/core/Box';
window.Box = Box;

import Button from '@material-ui/core/Button'
window.Button = Button;

import ButtonGroup from '@material-ui/core/ButtonGroup'
window.ButtonGroup = ButtonGroup;

import Card from '@material-ui/core/Card'
window.Card = Card

import CardActions from '@material-ui/core/CardActions'
window.CardActions = CardActions

import CardContent from '@material-ui/core/CardContent'
window.CardContent = CardContent

import CardHeader from '@material-ui/core/CardHeader'
window.CardHeader = CardHeader

import Checkbox from '@material-ui/core/Checkbox';
window.Checkbox = Checkbox;

import Chip from '@material-ui/core/Chip';
window.Chip = Chip;

import classnames from 'classnames';
window.classnames = classnames;

import CircularProgress from '@material-ui/core/CircularProgress';
window.CircularProgress = CircularProgress;

import Collapse from '@material-ui/core/Collapse'
window.Collapse = Collapse;

import Container from '@material-ui/core/Container'
window.Container = Container;

import LinearProgress from '@material-ui/core/LinearProgress';
window.LinearProgress = LinearProgress;

import Dialog from '@material-ui/core/Dialog';
window.Dialog = Dialog;

import DialogTitle from '@material-ui/core/DialogTitle';
window.DialogTitle = DialogTitle;

import DialogContent from '@material-ui/core/DialogContent';
window.DialogContent = DialogContent;

import DialogContentText from '@material-ui/core/DialogContentText';
window.DialogContentText = DialogContentText;

import DialogActions from '@material-ui/core/DialogActions';
window.DialogActions = DialogActions;

import Divider from '@material-ui/core/Divider';
window.Divider = Divider;

import Drawer from '@material-ui/core/Drawer';
window.Drawer = Drawer;

import FormGroup from '@material-ui/core/FormGroup';
window.FormGroup = FormGroup;

import FormControlLabel from '@material-ui/core/FormControlLabel';
window.FormControlLabel = FormControlLabel;

import FormControl from '@material-ui/core/FormControl';
window.FormControl = FormControl;

import FormHelperText from '@material-ui/core/FormHelperText';
window.FormHelperText = FormHelperText;

import FormLabel from '@material-ui/core/FormLabel';
window.FormLabel = FormLabel;

import Grid from '@material-ui/core/Grid';
window.Grid = Grid;

import Hidden from '@material-ui/core/Hidden';
window.Hidden = Hidden;

import IconButton from '@material-ui/core/IconButton';
window.IconButton = IconButton;

import Input from '@material-ui/core/Input';
window.Input = Input;

import InputLabel from '@material-ui/core/InputLabel';
window.InputLabel = InputLabel;

import InputAdornment from '@material-ui/core/InputAdornment';
window.InputAdornment = InputAdornment;

import Icon from '@material-ui/core/Icon';
window.Icon = Icon;

import Fade from '@material-ui/core/Fade';
window.Fade = Fade;

import List from '@material-ui/core/List';
window.List = List;

import ListItem from '@material-ui/core/ListItem';
window.ListItem = ListItem;

import ListItemIcon from '@material-ui/core/ListItemIcon';
window.ListItemIcon = ListItemIcon;

import ListItemText from '@material-ui/core/ListItemText';
window.ListItemText = ListItemText;

import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
window.ListItemSecondaryAction = ListItemSecondaryAction;

import Menu from '@material-ui/core/Menu';
window.Menu = Menu;

import MenuList from '@material-ui/core/MenuList';
window.MenuList = MenuList;
import MenuItem from '@material-ui/core/MenuItem';
window.MenuItem = MenuItem;

import Paper from '@material-ui/core/Paper';
window.Paper = Paper;

import Popover from '@material-ui/core/Popover';
window.Popover = Popover;

import Radio from '@material-ui/core/Radio';
window.Radio = Radio;

import RadioGroup from '@material-ui/core/RadioGroup';
window.RadioGroup = RadioGroup;

import Select from '@material-ui/core/Select';
window.Select = Select;

import Slider from '@material-ui/core/Slider';
window.Slider = Slider;

import Snackbar from '@material-ui/core/Snackbar'
window.Snackbar = Snackbar

import Stepper from '@material-ui/core/Stepper';
window.Stepper = Stepper;
import Step from '@material-ui/core/Step';
window.Step = Step;
import StepLabel from '@material-ui/core/StepLabel';
window.StepLabel = StepLabel;
import StepContent from '@material-ui/core/StepContent';
window.StepContent = StepContent;
import StepConnector from '@material-ui/core/StepConnector';
window.StepConnector = StepConnector;
import StepButton from '@material-ui/core/StepButton';
window.StepButton = StepButton;
import StepIcon from '@material-ui/core/StepIcon';
window.StepIcon = StepIcon;

import Switch from '@material-ui/core/Switch';
window.Switch = Switch;

import SvgIcon from '@material-ui/core/SvgIcon';
window.SvgIcon = SvgIcon;

import Tabs from '@material-ui/core/Tabs';
window.Tabs = Tabs;

import Tab from '@material-ui/core/Tab';
window.Tab = Tab;

import TabContext from '@material-ui/lab/TabContext';
window.TabContext = TabContext;

import TabPanel from '@material-ui/lab/TabPanel';
window.TabPanel = TabPanel;

import Table from '@material-ui/core/Table';
window.Table = Table;

import TableBody from '@material-ui/core/TableBody';
window.TableBody = TableBody;

import TableCell from '@material-ui/core/TableCell';
window.TableCell = TableCell;

import TableContainer from '@material-ui/core/TableContainer';
window.TableContainer = TableContainer;

import TableHead from '@material-ui/core/TableHead';
window.TableHead = TableHead;

import TableRow from '@material-ui/core/TableRow';
window.TableRow = TableRow;

import TextField from '@material-ui/core/TextField';
window.TextField = TextField;

import Toolbar from '@material-ui/core/Toolbar';
window.Toolbar = Toolbar;

import Tooltip from '@material-ui/core/Tooltip';
window.Tooltip = Tooltip;

import TvOffIcon from '@material-ui/icons/TvOff';
window.TvOffIcon = TvOffIcon;

import Typography from '@material-ui/core/Typography';
window.Typography = Typography;

import withMobileDialog from '@material-ui/core/withMobileDialog';
window.withMobileDialog = withMobileDialog;

import withWidth from '@material-ui/core/withWidth';
window.withWidth = withWidth;

import { alpha } from '@material-ui/core/styles/colorManipulator';
window.alpha = alpha;

import { createTheme, MuiThemeProvider, withTheme, withStyles } from '@material-ui/core/styles';
window.MuiThemeProvider = MuiThemeProvider;
window.withTheme = withTheme;
window.withStyles = withStyles;

import { ShieldCheckIcon } from '@heroicons/react/24/solid';
window.ShieldCheckIcon = ShieldCheckIcon;

import red from '@material-ui/core/colors/red';

(function () {
  var theme = {
    palette: {
      primary: {
        main: '#9ad52a',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#343945',
        contrastText: '#ffffff',
      },
      error: red,
    },
    props: {
      MuiIcon: {
        className: 'notranslate'
      }
    }
  };

  var el = document.querySelector('meta[name=mui-theme]');
  if (el)
    theme = JSON.parse(el.getAttribute('value'));

  // Violet Super Area palette (aligned with internal tooling standard)
  theme.palette.super = {
    dark: '#4c1d95',       // violet-900 (title text)
    main: '#ddd6fe',       // violet-200 (border)
    light: '#ede9fe',      // violet-100 (background)
    bright: '#8b5cf6',     // violet-500 (icons / accents)
    contrastText: '#4c1d95',
  };

  window.MuiTheme = createTheme(theme);
})();
